<template>
	<div>
		<div class="management-filters-wrapper">
			<div class="management-filters-flex-container">
				<SearchLabels
					:triggerSearchLabel="triggerSearchLabel"
					:setTextValue="setTextValue"
					:placeholder="`${$t('managementLabels.placeholder')}`"
				/>
				<div class="management-actions-container">
					<button class="management-filters-export-btn attribute-export" @click="openMenu('', 'create')">
						<img src="@/drc/assets/icons/plus.svg" :alt="$t('managementPage.export')">
						<span>{{ $t('crudSideMenu.new') }}</span>
					</button>
<!--					<button class="management-filters-export-btn">-->
<!--						<img src="@/drc/assets/icons/export.svg" :alt="$t('managementPage.export')">-->
<!--						<span>{{ $t('crudSideMenu.export') }}</span>-->
<!--					</button>-->
					<div class="filter-buttons">
						<div @click="toggleFilter('APPROVED')" class="filter-button filter-button-approved" :class="statusFilters.APPROVED.active ? 'selected' : ''">{{$t('managementLabels.approved')}}</div>
						<div @click="toggleFilter('FOR_APPROVAL')" class="filter-button filter-button-pending" :class="statusFilters.FOR_APPROVAL.active ? 'selected' : ''">{{$t('managementLabels.forApproval')}}</div>
						<div @click="toggleFilter('INACTIVE')" class="filter-button filter-button-inactive" :class="statusFilters.INACTIVE.active ? 'selected' : ''">{{$t('managementLabels.inactive')}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="management-static-table-container">
			<table>
				<tr>
					<th v-for="(header, index) in headers" :key="index" :class="header.key !== 'projectId' && header.key !== 'action' ? '' : 'unclickable'" @click="sortBy(header)">
						{{ header.label }}
						<img
							v-if="header.key === orderFieldName.key"
							:class="isSortHeader(header)"
							src="@/drc/assets/icons/arrow-down-white.svg"
							alt="sort"
						>
					</th>
				</tr>
				<tr v-for="(row, index) in rows" :key="row.id">
					<td>{{ row.name }}</td>
					<td class="attribute-type">
						<span class="tag" :class="row.type.toLowerCase()">
							{{ row.type === 'CERTIFICATION' ? $t('crudSideMenu.certification') : $t('crudSideMenu.tool') }}
						</span>
					</td>
					<td class="attribute-project-id">
						<span v-for="(project, index) in row.projects" :key="index">
							{{ index !== row.projects.length - 1 ? `${project.id},` : `${project.id}` }}
						</span>
						<span v-if="!row.projects || row.projects.length === 0">
							{{ $t('managementLabels.noProjects') }}
						</span>
					</td>
					<td class="attribute-created-date">
						{{ convertDate(row.createdDate) }}
					</td>
					<td class="attribute-creator">{{ row.createdBy }}</td>
					<td class="attribute-actions">
						<div class="button-container">
							<button class="table-action" @click="openMenu(row, 'edit')">{{ $t('crudSideMenu.edit') }}</button>
							<button class="table-action" @click="deleteRow(row)">{{ $t('crudSideMenu.delete') }}</button>
						</div>
					</td>
					<td class="attribute-status">
						<span :class="[
							'single-status',
							{'status-approved' : row.approvalStatus === 'APPROVED'},
							{'status-inactive' : row.approvalStatus === 'INACTIVE'},
							{'status-for-approval' : row.approvalStatus === 'FOR_APPROVAL'}]">
							{{
								row.approvalStatus === 'APPROVED'
									? $t('managementLabels.approved')
									: (row.approvalStatus === 'FOR_APPROVAL' ? $t('managementLabels.forApproval') : $t('managementLabels.inactive'))
							}}
						</span>

					</td>
					<td class="attribute-id">{{ row.id }}</td>
				</tr>

			</table>
		</div>
	</div>
</template>
<script>
import {EventCurdSideMenu, EventManagementContent} from "@/common/configurations/event-bus.js";
import * as SERVICES from "@/drc/services/drc-request-service";
import SearchLabels from "@/drc/components/SearchLabels"
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import {searchQualificationAttributes} from "@/drc/services/drc-graphql-service";

export default {
	name: "ManagementContentPanel",
	components: {
		SearchLabels
	},
	data() {
		return {
			downloadBtnStatus: true,
			isActive: false,
			rows: [],
			text: '',
			isLoading: false,
			currentPage: 0,
			isLoadingNextPage: false,
			orderFieldName: {
				key: 'approvalStatus',
				label: 'approvalStatus',
				createdDate: 'createdDate',
				sortType: 'DESC'
			},
			perPage: 999999,
			headers: [
				{
					key: 'name',
					label: this.$t('crudSideMenu.label')
				},
				{
					key: 'type',
					label: this.$t('crudSideMenu.type')
				},
				{
					key: 'projectId',
					label: this.$t('managementLabels.projectId')
				},
				{
					key: 'createdDate',
					label: this.$t('managementLabels.createdDate')
				},
				{
					key: 'createdBy',
					label: this.$t('crudSideMenu.createdBy')
				},
				{
					key: 'action',
					label: this.$t('crudSideMenu.action')
				},
				{
					key: 'approvalStatus',
					label: this.$t('crudSideMenu.status')
				},
				{
					key: 'id',
					label: this.$t('crudSideMenu.id')
				}
			],
			orderTypes: {
				ascending: 'ASC',
				descending: 'DESC'
			},
			isCrudModification: false,
			statusFilters:{
				APPROVED: {
					active: true,
					name: 'APPROVED',
				},
				INACTIVE: {
					active: false,
					name: 'INACTIVE',
				},
				FOR_APPROVAL: {
					active: true,
					name: 'FOR_APPROVAL',
				}
			}
		}
	},
	mounted() {
		this.setText();
		this.triggerSearchLabel();
	},
	created() {
		EventManagementContent.$on('refreshContent', this.refreshDatabasedOnCrudForm);
	},
	destroyed() {
		EventManagementContent.$off('refreshContent');
	},
	methods: {
		setText(){
			if (this.$route.query) {
				this.setTextValue(this.$route.query.text)
			}
		},
		toggleFilter(filter){
			this.statusFilters[filter].active = !this.statusFilters[filter].active;
			this.triggerSearchLabel();
		},
		convertDate(date) {
			date = new Date(date);

			const day = date.getUTCDate();
			const month = date.getUTCMonth() + 1;
			const year = date.getUTCFullYear();

			return `${day}.${month}.${year}`;
		},
		setTextValue(text) {
			this.text = text;
		},
		refreshDatabasedOnCrudForm() {
			this.isCrudModification = true;
			this.triggerSearchLabel();
		},
		triggerSearchLabel() {
			if (this.$store.getters.getDoShowLoading && this.isLoading) {
				return;
			}
			this.isLoading = true;
			this.$loader.show({
				text: '',
				description: '',
				buttonText: null,
				isBlue: false,
				onCancel: () => {
				}
			});
			const params = this.generateParams(this.text);
			searchQualificationAttributes(params)
				.then((response) => {
					response = response.filter(item => this.statusFilters[item.approvalStatus].active)
					if (this.orderFieldName.key === 'approvalStatus') {
						response.sort((a, b) => {
							if(params.sort.order === 'ASC'){
								if (a.approvalStatus === b.approvalStatus) {
									return new Date(a.createdDate) - new Date(b.createdDate);
								}
								return a.approvalStatus.localeCompare(b.approvalStatus);
							}else{
								if (a.approvalStatus === b.approvalStatus) {
									return new Date(b.createdDate) - new Date(a.createdDate);
								}
								return b.approvalStatus.localeCompare(a.approvalStatus);
							}
						});
					} else {
						response.sort((a, b) => {
							if(params.sort.order === 'ASC'){
								if (a[this.orderFieldName.key] === b[this.orderFieldName.key]) {
									return new Date(b.createdDate) - new Date(a.createdDate);
								}
								if(a[this.orderFieldName.key].localeCompare){
									return a[this.orderFieldName.key].localeCompare(b[this.orderFieldName.key]);
								}else{
									return a[this.orderFieldName.key] - b[this.orderFieldName.key];
								}
							}else{
								if (a[this.orderFieldName.key] === b[this.orderFieldName.key]) {
									return new Date(a.createdDate) - new Date(b.createdDate);
								}
								if(a[this.orderFieldName.key].localeCompare){
									return b[this.orderFieldName.key].localeCompare(a[this.orderFieldName.key]);
								}else{
									return b[this.orderFieldName.key] - a[this.orderFieldName.key];
								}
							}

						});
					}
					if (this.isLoadingNextPage && this.currentPage > 0) {
						this.rows.push(...response)
					} else {
						this.rows = response;
					}
				})
				.catch((error) => {
					console.error(error);
					this.showNotification(this.$t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
				})
				.finally(() => {
					this.isLoading = false;
					this.isCrudModification = false;
					this.$loader.hide();
				})
		},
		deleteRow(row) {
			this.$dialog.openPopupModal({
				title: `${this.$t('crudSideMenu.areYouSureYouWantToDelete')}`,
				text: `${this.$t('crudSideMenu.willNoLongerBeAssociatedWithAnyProject')}`,
				onConfirm: () => {
					SERVICES.deleteAttribute(row.id).then(() => {
						this.showNotification(this.$i18n.t('formsNotifications.toolCertificateDeletedSuccessfully'), NOTIFICATION_TYPE.SUCCESS);
						this.triggerSearchLabel();
						if (row.id && row.type && row.name) {
							localStorage.setItem('deleteAttribute', JSON.stringify({id: row.id, name: row.name, type: row.type}));
						}
					}).catch((error) => {
						this.showNotification(this.$i18n.t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
						console.error(error);
					})
				}
			})
		},
		openMenu(row, mode) {
			let data = {
				type: mode,
				row: row
			};

			EventCurdSideMenu.$emit('toggle-side-menu', data);
		},
		generateParams(text){
			const criteria = {}
			criteria.hasSubmissions = true;
			criteria.pageable = {
				page: this.currentPage,
				size: this.perPage
			}
			criteria.sort = {
				by: this.orderFieldName.key,
				order: this.orderFieldName.sortType || this.orderTypes.ascending
			}
			criteria.sort.order = criteria.sort.order.toUpperCase();

			criteria.text = text ? text.trim() : null;
			if (text && text.trim() !== "" || this.isCrudModification) {
				this.currentPage = 0;
			}

			return criteria

		},
		sortBy(header) {
			if (header.key !== "action" && header.key !== "projectId") {
				if (this.orderFieldName.key === header.key) {
					if (!this.orderFieldName.sortType) {
						this.orderFieldName.sortType = this.orderTypes.descending;
					} else if (this.orderFieldName.sortType && this.orderFieldName.sortType !== this.orderTypes.descending) {
						this.orderFieldName.sortType = this.orderTypes.descending;
					} else {
						this.orderFieldName.sortType = this.orderTypes.ascending;
					}
				} else {
					this.orderFieldName = header;
				}
				this.isLoadingNextPage = false;
				this.currentPage = 0;
				this.triggerSearchLabel();
			}
		},
		scrollHandler() {
			let currentPosition = this.$parent.$parent.$refs.mainContent.scrollTop;
			let bottom = this.$parent.$parent.$refs.mainContent.scrollHeight - window.innerHeight;
			if (currentPosition > bottom) {
				this.addScrollProjects();
			}
		},
		addScrollProjects() {
			if (this.isLoading) return;
			this.currentPage = this.currentPage + 1;
			this.isLoadingNextPage = true;
			this.triggerSearchLabel();
		},
		isSortHeader(header) {
			if (header.key === this.orderFieldName.key && this.orderFieldName.sortType !== this.orderTypes.descending) {
				return 'rotated';
			}
			return '';
		}
	},
	watch: {
		'orderFieldName.key': function (newKey, oldKey) {
			this.currentPage = 0;
			this.triggerSearchLabel();
		},
		'$i18n.locale': {
			immediate: true,
			handler() {
				this.headers = [
					{
						key: 'name',
						label: this.$t('crudSideMenu.label')
					},
					{
						key: 'type',
						label: this.$t('crudSideMenu.type')
					},
					{
						key: 'projectId',
						label: this.$t('managementLabels.projectId')
					},
					{
						key: 'createdDate',
						label: this.$t('managementLabels.createdDate')
					},
					{
						key: 'createdBy',
						label: this.$t('crudSideMenu.createdBy')
					},
					{
						key: 'action',
						label: this.$t('crudSideMenu.action')
					},
					{
						key: 'approvalStatus',
						label: this.$t('crudSideMenu.status')
					},
					{
						key: 'id',
						label: this.$t('crudSideMenu.id')
					}
				]
			}
		}
	}
}
</script>
<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.rotated {
	transform: rotate(180deg);
}

.attribute-type {
	width: 140px;
}

.attribute-status {
	width: 140px;

	.single-status {
		padding: 5px 10px;
		border-radius: 4px;
		font-size: 12px;
		word-break: keep-all;
		white-space: nowrap;
	}

	.status-approved {
		background: #7CB861;
	}

	.status-inactive {
		background: #7A7A7A;
	}

	.status-for-approval {
		background: $color-hover-button;
		color: black;
	}
}

.attribute-project-id {
	width: 120px;
}

.attribute-creator {
	width: 290px;
}

.attribute-actions {
	width: 140px;

	.button-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex-wrap: wrap;
		align-items: center;
		gap: 8px;

		button {
			width: 100%;
			flex: 1;
		}
	}
}

.attribute-id {
	width: 120px;
}


</style>
